import React from "react";

import {
    FooterNavigationMenuBlock,
    ServerCmsContextProcessorsNavigationProcessor,
} from "@reactivated";

import {
    StreamField,
    StreamFieldBlockMap,
} from "@thelabnyc/thelabui/src/components/StreamField";

import { Svg } from "../Svg";
import { FooterCtaBlock } from "./FooterCtaBlock";
import { FooterLinks } from "./FooterLinks";

import styles from "./index.module.scss";

interface Props {
    footer_nav: ServerCmsContextProcessorsNavigationProcessor["footer_nav"];
}

const footerComponents: StreamFieldBlockMap<FooterNavigationMenuBlock> = {
    cta: FooterCtaBlock,
    links: FooterLinks,
};

export const FooterNavigation = ({ footer_nav }: Props) => {
    if (!footer_nav) return <></>;
    const nav = footer_nav.nav;

    return (
        <footer className={styles.root}>
            <div className={styles.grid}>
                <div className={styles.inner}>
                    <StreamField
                        tagName={React.Fragment}
                        components={footerComponents}
                        value={nav.value}
                    />
                    <Svg name="logo-xcient-gradient" className={styles.logo} />
                </div>
            </div>
        </footer>
    );
};
